import moment from 'moment-timezone'
import {sorterNum} from 'Utils'

export const transactions = (isIntraday) => [{
  title: 'Date',
  dataIndex: 'actual_execution_date',
  sorter: (a, b) => new Date(a.actual_execution_date) - new Date(b.actual_execution_date),
  render: (x) => {
    if (x == null) {
      return '-'
    } else {
      const dt = moment(x).tz('US/Eastern')
      if (!dt._isValid) {
        return '-'
      } else if (isIntraday) {
        return dt.format('L LTS')
      } else {
        return dt.format('L')
      }
    }
  }
}, {
  title: 'Ticker',
  dataIndex: 'ticker',
  sorter: (a, b) => a.ticker.localeCompare(b.ticker),
  render: (text) => text.replace('CRYPTO-', '')
}, {
  title: 'Transaction',
  dataIndex: 'action',
  sorter: (a, b) => a.action.localeCompare(b.action)
}, {
  title: 'Amount',
  dataIndex: 'amount',
  sorter: (a, b) => sorterNum(a.amount, b.amount)
}, {
  title: 'Price',
  dataIndex: 'price',
  sorter: (a, b) => sorterNum(a.price, b.price)
}, {
  title: 'Cost',
  dataIndex: 'cost',
  sorter: (a, b) => sorterNum(a.cost, b.cost)
}]

export const positions = [{
  title: 'Ticker',
  dataIndex: 'ticker',
  sorter: (a, b) => a.ticker.localeCompare(b.ticker),
  render: (text) => text.replace('CRYPTO-', '')
}, {
  title: 'Shares',
  dataIndex: 'amount',
  sorter: (a, b) => sorterNum(a.amount, b.amount)
}, {
  title: 'Current price',
  dataIndex: 'current_price',
  sorter: (a, b) => sorterNum(a.current_price, b.current_price)
}, {
  title: 'Avg. buy price',
  dataIndex: 'avg_buy_price',
  sorter: (a, b) => sorterNum(a.avg_buy_price, b.avg_buy_price)
}, {
  title: 'Avg. sell price',
  dataIndex: 'avg_sell_price',
  sorter: (a, b) => sorterNum(a.avg_sell_price, b.avg_sell_price)
}, {
  title: 'Value',
  dataIndex: 'current_value',
  sorter: (a, b) => sorterNum(a.current_value, b.current_value)
}, {
  title: 'Unrealized PnL',
  dataIndex: 'unrealized_pnl',
  sorter: (a, b) => sorterNum(a.unrealized_pnl, b.unrealized_pnl)
}]
